
const TermsSection = () => {
  return (
    <div className="flex items-center">
      <input
        id="terms"
        name="terms"
        type="checkbox"
        required
        className="h-4 w-4 rounded border-gray-300 text-socialsync-600 focus:ring-socialsync-500"
      />
      <label htmlFor="terms" className="ml-2 block text-sm text-gray-900">
        J'accepte les{" "}
        <a href="#" className="font-medium text-socialsync-600 hover:text-socialsync-500">
          conditions d'utilisation
        </a>{" "}
        et la{" "}
        <a href="#" className="font-medium text-socialsync-600 hover:text-socialsync-500">
          politique de confidentialité
        </a>
      </label>
    </div>
  );
};

export default TermsSection;
